import { FC, useState } from "react";
import {
    EnhancedTextAreaFieldRHF,
    ITest,
    LabelPosition,
    RHookFormMaskedTextFieldWithLabel,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

interface ITrustBankSetupFieldsRightPanel extends ITest {
   
}
export const TrustBankSetupFieldsRightPanel: FC<
    ITrustBankSetupFieldsRightPanel
> = ({  }) => {
 

    return (
        <>
            <RHookFormTextFieldWithLabel
                id="clientName"
                testId={`client-name`}
                label="Client Name"
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                id="clientShortName"
                testId={`client-short-name`}
                label="Client Short Name"
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                id="bankAccountNo"
                testId={`bank-account-no`}
                label="Bank Account No"
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                id="financialInstitutionNo"
                testId={`financial-institution-no`}
                label="Financial Institution No"
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                id="bankTransitNo"
                testId={`bank-Transit-Number`}
                label="Bank Transit No"
                labelPosition={LabelPosition.Top}
            />

            {/* <RHookFormMaskedTextFieldWithLabel
                id="bankAccountNo"
                testId={`bank-account-no`}
                label="Bank Account No"
                inputMaskPattern="00000"
                placeholder="022*******"
            />
            <RHookFormMaskedTextFieldWithLabel
                id="financialInstitutionNo"
                testId={`financial-institution-no`}
                label="Financial Institution No"
                inputMaskPattern="00000"
                placeholder="0**"
            />

            <RHookFormMaskedTextFieldWithLabel
                id="bankTransitNo"
                testId={`bank-Transit-Number`}
                label="Bank Transit No."
                inputMaskPattern="00000"
                placeholder="03***"
            /> */}
            <RHookFormTextFieldWithLabel
                id="accountTitle"
                testId={`account-title`}
                label="Account Title"
                labelPosition={LabelPosition.Top}
            />
            <EnhancedTextAreaFieldRHF
                id="emailForUpload"
                label="Email For Upload"
                testId={`email-for-upload`}
                labelPosition={LabelPosition.Top}
            // placeholder="dddd"
            // labelColumns={4}
            // fieldColumns={7}
            />
        </>
    );
};
